export default __webpack_public_path__ + "static/media/99t.986e789d.jpg";